import { Box, Heading, Text } from "@chakra-ui/react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import "./Skills.css";
import React from "react";

const SkillTypes = {
  SKILL: "skill",
};

function SkillItem({ name, icon, index, type, moveSkill }) {
  const [{ isDragging }, drag] = useDrag({
    type: SkillTypes.SKILL,
    item: { name, icon, index, type },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: SkillTypes.SKILL,
    hover: (item, monitor) => {
      if (!drag || !drop) {
        return;
      }
      if (item.index === index) {
        return;
      }

      const hoverIndex = index;
      const dragIndex = item.index;
      const sourceType = item.type;

      moveSkill(dragIndex, hoverIndex, sourceType);
      item.index = hoverIndex;
    },
  });

  return (
    <li ref={(node) => drag(drop(node))} style={{ opacity: isDragging ? 0.5 : 1 }}>
      {/* <a href="#" className="skills-card-name"> */}
        <span className="skills-card-img">
          <i className={icon}></i>
        </span>
        {name}
      {/* </a> */}
    </li>
  );
}

function Skills() {
  const [frontendSkills, setFrontendSkills] = React.useState([
    { name: "HTML5", icon: "fa-brands fa-html5", type: "frontend" },
    { name: "CSS3", icon: "fa-brands fa-css3-alt", type: "frontend" },
    { name: "JavaScript", icon: "fa-brands fa-square-js", type: "frontend" },
    { name: "React JS", icon: "fa-brands fa-react", type: "frontend" },
    { name: "TypeScript", type: "frontend" },
    { name: "Chakra UI", type: "frontend" },
  ]);

  const [backendSkills, setBackendSkills] = React.useState([
    { name: "Node.js", icon: "fa-brands fa-node", type: "backend" },
    { name: "Express.js", type: "backend" },
    { name: "Mongodb", type: "backend" },
    { name: "Java", icon: "fa-brands fa-java", type: "backend" },
    { name: "SQL", type: "backend" },
  ]);

  const moveSkill = (dragIndex, hoverIndex, sourceType) => {
    const sourceList = sourceType === "frontend" ? frontendSkills : backendSkills;
    const dragSkill = sourceList[dragIndex];
    const updatedList = [...sourceList];
    updatedList.splice(dragIndex, 1);
    updatedList.splice(hoverIndex, 0, dragSkill);

    if (sourceType === "frontend") {
      setFrontendSkills(updatedList);
    } else {
      setBackendSkills(updatedList);
    }
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <Box
        id="skills"
        background="#040724"
        w={["90%", "90%", "90%", "90%", "90%"]}
        m={"auto"}
        p="30px 0px"
        borderRadius={"10px"}
        paddingTop={["100px", "80px", "30px", "70px", "70px"]}
        textAlign="center"
      >
        <Heading
          fontSize={["3xl", "3xl", "7xl", "4xl", "5xl"]}
          fontWeight="400"
          color={"#00b9e8"}
          align={"center"}
          justifyContent={"center"}
        >
          <Text align={"center"} justifyContent={"center"} color={"#00b9e8"}>
            SKILLS
          </Text>
        </Heading>
        <Box
          className="skills-card"
          style={{ display: "flex", background: "#040724" }}
          mt={["60px", "20px", "-162px", "39px", "39px"]}
          w={["90%", "90%", "100%", "100%", "90%"]}
          m={"auto"}
        >
          <ul>
            <ol>FRONTEND</ol>
            {frontendSkills.map((skill, index) => (
              <SkillItem
                key={skill.name}
                name={skill.name}
                icon={skill.icon}
                index={index}
                type="frontend"
                moveSkill={moveSkill}
              />
            ))}
          </ul>
          <ul style={{ marginLeft: "370px" }}>
            <ol>BACKEND</ol>
            {backendSkills.map((skill, index) => (
              <SkillItem
                key={skill.name}
                name={skill.name}
                icon={skill.icon}
                index={index}
                type="backend"
                moveSkill={moveSkill}
              />
            ))}
          </ul>
        </Box>
      </Box>
    </DndProvider>
  );
}

export default Skills;





// import { Box, Heading, Text } from "@chakra-ui/react";
// import "./Skills.css";
// // import { SiMusicbrainz } from "react-icons/si";

// function Skills() {
//   return (
//     <Box 
      
//       id="skills" 
//       // h={["1150px", "1170px", "700px"]} 
//       background="#040724" 
//       w={["90%","90%","90%","90%","90%"]}
//       m={"auto"}
//       p="30px 0px"
//     // bg="#040724"
//         borderRadius={"10px"}
//     paddingTop={["100px", "80px", "30px", "70px", "70px"]}
//     textAlign="center">
//       <Heading
//         // mr={["10%", "0%", "5%"]}
//         fontSize={["3xl", "3xl", "7xl", "4xl", "5xl"]}
//         fontWeight="400"
//         color={"#00b9e8"}
//         align={"center"}
//         justifyContent={"center"}
//       >
//         <Text align={"center"}
//             justifyContent={"center"} color={"#00b9e8"} >
//           SKILLS
//         </Text>
//         {/* <Text
//           mt={["-40px", "-40px", "-82px", "-39px", "-53px"]}
//           marginLeft={["190px", "348px", "568px", "600px", "820px"]}
//           fontSize={["3xl", "3xl","7xl", "4xl", "5xl"]}
//         >
//           <SiMusicbrainz color="#00b9e8" className="bounce" />
//         </Text> */}
//       </Heading>
//       <Box
//         className="skills-card"
//         style={{ display: "flex", background: "#040724" }}
//         mt={["60px", "20px", "-162px", "39px", "39px"]}
//         // border={"1px solid white"}
//         w={["90%", "90%", "100%", "100%", "90%"]}
//         m={"auto"}
//       >
//         <ul>
//           <ol>FRONTEND</ol>
//           <li>
//             <a href="." className="skills-card-name">
//               <span className="skills-card-img">
//                 <i class="fa-brands fa-html5"></i>
//               </span>
//               HTML5
//             </a>
//           </li>
//           <li>
//             <a href=".">
//               <span>
//                 <i class="fa-brands fa-css3-alt"></i>
//               </span>
//               CSS3
//             </a>
//           </li>
//           <li>
//             <a href=".">
//               <span>
//                 <i class="fa-brands fa-square-js"></i>
//               </span>
//               JavaScript
//             </a>
//           </li>
//           <li>
//             <a href="." class="skills-card-name">
//               <span class="skills-card-img">
//                 <i class="fa-brands fa-react"></i>
//               </span>
//               React JS
//             </a>
//           </li>
//           <li>
//             <a href="." class="skills-card-name">
//               <span></span>TypeScript
//             </a>
//           </li>
//           <li>
//             <a href="." class="skills-card-name">
//               <span></span>Chakra UI
//             </a>
//           </li>
//         </ul>
//         <ul style={{ marginLeft: "370px" }}>
//           <ol>BACKEND</ol>
//           <li>
//             <a href="." class="skills-card-name">
//               <span class="skills-card-img">
//                 <i class="fa-brands fa-node"></i>
//               </span>
//               Node.js
//             </a>
//           </li>
//           <li>
//             <a href="." class="skills-card-name">
//               <span class="skills-card-img"></span>Express.js
//             </a>
//           </li>
//           <li>
//             <a href="." class="skills-card-name">
//               <span class="skills-card-img"></span>Mongodb
//             </a>
//           </li>
//           <li>
//             <a href="." class="skills-card-name">
//               <span class="skills-card-img">
//                 <i class="fa-brands fa-java"></i>
//               </span>
//               Java
//             </a>
//           </li>
//           <li>
//             <a href="." class="skills-card-name">
//               <span class="skills-card-img"></span>SQL
//             </a>
//           </li>
//         </ul>
//       </Box>
//     </Box>
//   );
// }
// export default Skills;
